import React from 'react'
import { useTranslation } from 'react-i18next'
import './BroadSignCreationPreviewModal.scss'
import Modal from '../../../../components/Modal'
import Button, { ButtonTheme } from '../../../../components/Form/Button'
import { BroadSignCreationModel } from '../../../../api/broadSign/models/broad-sign-creation.model'

const BroadSignCreationPreviewModal: React.FC<{
  creation?: BroadSignCreationModel
  isModalOpen: boolean
  setModalOpen: (open: boolean) => void
}> = ({ creation, isModalOpen, setModalOpen }) => {
  const { t } = useTranslation()
  return (
    <Modal
      title={`${t('broadSign.preview')}`}
      classNameOverlay='BroadSignCreationPreviewModal'
      isOpen={isModalOpen}
      onClose={(isOpen: boolean) => void setModalOpen(isOpen)}
      footer={
        <div className={'BroadSignCreationPreviewModal__footer'}>
          <Button
            theme={ButtonTheme.BLUE}
            onClick={() => void setModalOpen(false)}
          >
            {t('common.close')}
          </Button>
        </div>
      }
    >
      {isModalOpen && creation && (
        <div>
          {creation.file.isVideo ? (
            <video
              className={'BroadSignCreationPreviewModal__media'}
              width='100%'
              height='100%'
              controls
            >
              <source
                src={creation.file.url}
                type={creation.file.mimeType}
              />
              {t('broadSign.noSupport')}
            </video>
          ) : (
            <img
              className={'BroadSignCreationPreviewModal__media'}
              src={creation.file.url}
              alt={creation.file.filename}
            />
          )}
        </div>
      )}
    </Modal>
  )
}

export default BroadSignCreationPreviewModal
